import { coverageMetricApi } from "api/immunization";
import MasterListScreen from "./common/MasterListScreen";
import CoverageMetricModal from "./CoverageMetricModal";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}-${month}-${date.getFullYear()}`;
};

const CoverageMetricList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={coverageMetricApi}
    label="Coverage metric"
    entityLabel="coverage metric"
    addLabel="Add Metric Version"
    tag="immunization-coverage-metric"
    headers={[
      "Name",
      "Code",
      "Body",
      "Effective",
      "Denominator",
      "Antigens",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "standardBody",
      "effectiveLabel",
      "denominatorLabel",
      "antigenCount",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.name}
    mapRow={(item) => ({
      effectiveLabel: `${formatDate(item.effectiveFrom)} → ${
        item.effectiveTo ? formatDate(item.effectiveTo) : "current"
      }`,
      denominatorLabel: item.denominator?.cohortCode || "All patients",
      antigenCount: (item.numeratorAntigenCodes || []).length || "—",
    })}
    Modal={CoverageMetricModal}
    searchText={searchText}
  />
);

export default CoverageMetricList;
